import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 44 44",
    class: "icon-fi icon-fi-home"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      transform: "translate(-2.375 -1.375)",
      class: ""
    }, [
      _createElementVNode("path", {
        d: "M15.4,20.4l9-7l9,7v11c0,1.1-0.9,2-2,2h-14c-1.1,0-2-0.9-2-2V20.4z",
        class: "icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
      }),
      _createElementVNode("path", {
        d: "M21.4,33.4v-10h6v10",
        class: "icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
      })
    ], -1)
  ]), 16))
}
export default { render: render }